import { ClientSettingsDto } from '@suite/client-settings-api';

export class ClientSettings {
  readonly key: string;
  readonly value: Record<string, any>;

  private constructor(dto: ClientSettingsDto) {
    this.key = dto.key;
    this.value = this.decodeValue(dto.value);
  }

  static fromDto(dto: ClientSettingsDto): ClientSettings {
    return new ClientSettings(dto);
  }

  static toDto(clientSettings: Partial<ClientSettings>): Partial<ClientSettingsDto> {
    const dto: Partial<ClientSettingsDto> = {};
    
    if (clientSettings.key) {
      dto.key = clientSettings.key;
    }
    
    if (clientSettings.value) {
      dto.value = ClientSettings.encodeValue(clientSettings.value);
    }
    
    return dto;
  }

  private decodeValue(encodedValue: string): Record<string, any> {
    try {
      const decoded = window.atob(encodedValue || '');
      const unescaped = decodeURIComponent(decoded);
      return JSON.parse(unescaped);
    } catch {
      return {};
    }
  }

  private static encodeValue(value: Record<string, any>): string {
    try {
      const str = JSON.stringify(value);
      const escaped = encodeURIComponent(str);
      return window.btoa(escaped);
    } catch {
      return '';
    }
  }
}